import type { ClaimPreview } from "@hobbyshopify/backend-client";
import { Rx } from "subtree.js/core";

export type ClaimFlow =
  | { step: "login"; busy: boolean; error?: string }
  | { step: "checking" }
  | { step: "preview-error"; error: string }
  | { step: "connect"; shop: ClaimPreview; busy: boolean; error?: string };

export class ShopClaimState {
  /** The one-time bearer from the invitation link; null when the URL had none. */
  readonly token: Rx<string | null>;
  /** The session is still restoring, or the profile of a signed-in account is still loading. */
  readonly loading = new Rx(true);
  readonly profileFailed = new Rx(false);
  /** Signed in as a registered merchant with a loaded profile: the account that can redeem. */
  readonly registered = new Rx(false);
  readonly flow = new Rx<ClaimFlow>({ step: "login", busy: false });

  constructor(token: string | null) {
    this.token = new Rx(token);
  }
}

export abstract class ShopClaimActions {
  abstract continueWithGoogle(): Promise<void>;
  abstract continueWithApple(): Promise<void>;
  /** Checks the invitation again after a preview failure. */
  abstract checkInvitation(): Promise<void>;
  abstract connect(): Promise<void>;
  abstract close(): void;
  abstract goToLogin(): void;
}
